module.exports = __webpack_public_path__ + "static/media/image-card-12.7f50d68a.png";